import { useProviderDetailStore } from "../../store/provider-details/providerDetailStore";

import ProviderField from "./ProviderField";
import ProviderTypeList from "./ProviderTypeList";

export default function ProviderContact({ data }) {
  const { communicationPreferenceTypes } = useProviderDetailStore();
  const providerTypes = data?.providerTypes ?? [];
  const activeStateName = data?.activeStateName ?? null;
  const address = data?.address ?? null;
  const website = data?.homepage ?? null;
  const commPreference = data?.communicationPreference ?? null;
  const phone = data?.phone ?? null;
  const mainEmail = data?.email ?? null;

  return (
    <div className="flex flex-col gap-2 p-2">
      <ProviderTypeList data={providerTypes} />
      <ProviderField label="Active State" data={activeStateName} />
      <ProviderField label="Address" data={address} renderValue={(value) => value.raw} />
      <ProviderField label="Website URL" data={website} />
      <ProviderField
        label="Communication Preference"
        data={
          communicationPreferenceTypes.find((item) => item.key === Number(commPreference))?.label
        }
      />
      <ProviderField label="Phone Number" data={phone} />
      <ProviderField label="Main Email" data={mainEmail} />
    </div>
  );
}
